module.exports = __webpack_public_path__ + "static/media/sms-icon.ca80f6f3.svg";